import { Instance } from 'mobx-state-tree';
import actions from './actions';
import model from './model';
import views from './views';
import WidgetProcessor from '../processor';

const DistributionWidget = model.views(views).actions(actions);

export interface IDistributionWidget extends Instance<typeof DistributionWidget> {}

export default WidgetProcessor(DistributionWidget);
